export var constants = {
  pitch_bound: 30,
  vario_bound: 1.95,
  airspeed_bound_l: 0,
  airspeed_bound_h: 160
};

export interface IInstrumentProps {
  showBox?: boolean;
}
